import React, { useState } from 'react';
import ManageDialogView from './ManageDialogView';

const ManageDialog = ({ open, onClose }) => {
    return <ManageDialogView open={open} onClose={onClose} />;
};

export default ManageDialog;